<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/mail/black</title>
    <g id="atoms/icons/30x30/mail/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M23.4,6 C25.0568542,6 26.4,7.34314575 26.4,9 L26.4,21 C26.4,22.6568542 25.0568542,24 23.4,24 L6.6,24 C4.94314575,24 3.6,22.6568542 3.6,21 L3.6,9 C3.6,7.34314575 4.94314575,6 6.6,6 L23.4,6 Z M11.956,16.5658196 L5.6,20.703 L5.6,21 C5.6,21.5522847 6.04771525,22 6.6,22 L23.4,22 C23.9522847,22 24.4,21.5522847 24.4,21 L24.4,20.494 L18.394,16.5848196 L15.93344,18.2467977 C15.5569185,18.4706503 15.1352855,18.4706503 14.749195,18.3131985 C14.5428393,18.2290444 14.2991672,18.0798912 13.9989484,17.8691273 L11.956,16.5658196 Z M5.6,12.511 L5.6,18.316 L10.105,15.3848196 L5.6,12.511 Z M24.4,12.532 L20.195,15.3708196 L24.4,18.108 L24.4,12.532 Z M23.4,8 L6.6,8 C6.04771525,8 5.6,8.44771525 5.6,9 L5.6,10.139 L5.85867759,10.3040757 L15.1093743,16.2062378 C15.158581,16.2406074 15.2043092,16.2718882 15.2459367,16.2998516 L24.4,10.119 L24.4,9 C24.4,8.44771525 23.9522847,8 23.4,8 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
